import EnableSmartFilterButton from "./modules/screen-options/smart-filter-button";
document.addEventListener('DOMContentLoaded', function () {
    AdminColumns.SearchOptions = new EnableSmartFilterButton();
});
